import React, { useMemo, useRef, useState } from "react";
import "./ExperienceTimeline.css";
import "../../components/timeline/Timeline.css";
import ExperienceCard from "../../components/experienceCard/ExperienceCard";
import useTimeline from "../../components/timeline/useTimeline";

// Filterable career timeline built from experience.sections.
export default function ExperienceTimeline({ sections }) {
  const root = useRef(null);
  const [filter, setFilter] = useState("All");

  const all = useMemo(
    () =>
      sections.flatMap((s) =>
        s.experiences.map((e) => ({ ...e, section: s.title }))
      ),
    [sections]
  );
  const tabs = useMemo(
    () => [
      { name: "All", count: all.length },
      ...sections.map((s) => ({ name: s.title, count: s.experiences.length })),
    ],
    [sections, all]
  );
  const shown = filter === "All" ? all : all.filter((e) => e.section === filter);
  const idx = Math.max(tabs.findIndex((t) => t.name === filter), 0);

  useTimeline(root, [filter]);

  return (
    <div className="exp-timeline" ref={root}>
      <div
        className="seg"
        role="tablist"
        aria-label="Filter experience"
        style={{ "--n": tabs.length, "--i": idx }}
      >
        <span className="seg-pill" aria-hidden="true" />
        {tabs.map((t) => (
          <button
            key={t.name}
            type="button"
            role="tab"
            aria-selected={filter === t.name}
            className={`seg-btn${filter === t.name ? " on" : ""}`}
            onClick={() => setFilter(t.name)}
          >
            {t.name} <em>{t.count}</em>
          </button>
        ))}
      </div>

      <div className="tl" key={filter}>
        <div className="tl-line" aria-hidden="true" />
        <div className="tl-progress" aria-hidden="true" />
        <ul className="tl-list">
          {shown.map((e) => (
            <li
              className="tl-item"
              key={`${e.company}-${e.title}`}
              style={{ "--c": e.color }}
            >
              <span className="tl-node" aria-hidden="true" />
              <ExperienceCard experience={e} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
